import { StyledCell } from './styles';
import React, { useCallback } from 'react';
import { DashboardScrollTable } from '../../Components/DashboardTable/DashboardScrollTable';

interface Props {
  rows: any[];
  loadMore: () => void;
  loading: boolean;
  hasMore: boolean;
  totalItems: number;
}

const headCells: HeadCell[] = [
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Name',
  },
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'Id',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: 'Type',
  },
];

export const ClientTable = ({ rows, loadMore, loading, hasMore, totalItems }: Props) => {
  const handleLoadMore = useCallback(() => {
    if (hasMore && !loading) {
      loadMore();
    }
  }, [hasMore, loading, loadMore]);

  const rowContent = (_index: number, row: any) => {
    return (
      <React.Fragment>
        <StyledCell>{row.name}</StyledCell>
        <StyledCell id={row.id} scope="row">
          {row.id}
        </StyledCell>
        <StyledCell>{row.type}</StyledCell>
      </React.Fragment>
    );
  };
  return (
    <DashboardScrollTable
      headerCells={headCells}
      rows={rows}
      loadMore={handleLoadMore}
      hasMore={hasMore}
      rowContent={rowContent}
      totalItems={totalItems}
    />
  );
};
